import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';
import { InternalScheduleActionsProps } from './types';

export const InternalScheduleActions = ({
  onCancel,
  onRemove,
  onSendSchedule,
  onRescheduleAsDraft,
  onSaveAsDraft,
  locked,
  scheduleId,
  foremanId,
  readOnly = false,
  isDraft = false,
}: InternalScheduleActionsProps) => {
  const { t } = useTranslation('app');

  const isNewSchedule = scheduleId === 'new' || !scheduleId;
  const remove = !readOnly && onRemove && scheduleId && scheduleId !== 'new';
  const send = !readOnly && onSendSchedule && (isDraft || isNewSchedule) && foremanId;

  return (
    <div className="flex flex-col gap-2">
      {isDraft && (
        <span className="text-right text-sm text-neutral-700">
          {t('schedules.saveAsDraftTooltip')}
        </span>
      )}
      <div className="flex items-center justify-end gap-2">
        <Button variant="ghost" onClick={onCancel}>
          {t('actions.cancel')}
        </Button>
        {remove && (
          <Button onClick={onRemove} variant="dangerSecondary">
            {t('actions.removeSchedule')}
          </Button>
        )}
        {!readOnly && !isDraft && (
          <Button
            type={!isNewSchedule && onRescheduleAsDraft ? 'button' : 'submit'}
            disabled={locked}
            onClick={!isNewSchedule && onRescheduleAsDraft ? onRescheduleAsDraft : onSaveAsDraft}>
            {isNewSchedule ? t('actions.saveAsDraft') : t('actions.saveDraft')}
          </Button>
        )}
        {!readOnly && !isNewSchedule && (
          <Button disabled={locked} type="submit" onClick={isDraft ? onSaveAsDraft : undefined}>
            {t('actions.reschedule')}
          </Button>
        )}
        {send && (
          <Button disabled={locked} onClick={onSendSchedule}>
            <SvgConsumer id="message" className="text-lg" />
            {t('actions.sendSchedule')}
          </Button>
        )}
      </div>
    </div>
  );
};
